<template>
  <button type="button" class="def-swiper-button-prev">
    <svg
      class="def-swiper-button-prev__icon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.3522 11.9999L15.375 3.97712L16.6478 5.24991L9.89779 11.9999L16.6478 18.7499L15.375 20.0227L7.3522 11.9999Z"
        fill="#191918"
      />
    </svg>
  </button>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.def-swiper-button-prev {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 36px;
  border-radius: 8px;
  background: rgba(97, 142, 175, 0.35);
  transition: 0.2s linear background-color;
  padding: 0;
  @include point-md {
    width: 24px;
    height: 36px;
  }
  @include point-lg {
    width: 32px;
    height: 48px;
  }
  &:not(.swiper-button-disabled):hover {
    background-color: rgb(97, 142, 175);
  }
  &.swiper-button-disabled {
    cursor: not-allowed;
  }
  &__icon {
    width: 18px;
    height: 18px;
    @include point-lg {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
